import getApi from '../../api'
import { OnGoingTranscriptionAI } from '../../model/TranscriptionAI'

export const checkTranscription = () =>
  getApi().get<OnGoingTranscriptionAI>(`/voice_ai/transcribe/check`)
